<template>
  <nav 
    :class="classList"
    class="Menu">
    <Link 
      v-for="item in items" 
      :key="item.to.name" 
      :to="item.to" 
      :arrow="arrow"
      :label="item.label"
      :alternate="item.alternate"
      class="Menu__link" />
  </nav>
</template>

<script>

import Link from '@/components/Link';

export default {
  name: 'Menu',
  components: {
    Link
  },
  props: {
    // Menu items
    items: {
      type: Array,
      required: true
    },
    arrow: {
      type: Boolean,
      default: false
    },
    horizontal: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    classList() {
      return {
        'Menu--horizontal' : this.horizontal
      }
    }
  }
}
</script>

<style lang="scss">
  .Menu {
    display: flex;
    flex-direction: column;
    user-select: none;

    &--horizontal {
      flex-direction: row;
    }
  }
</style>
